/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskZoomInfoScanResult } from './ExecRiskZoomInfoScanResult';
import {
    ExecRiskZoomInfoScanResultFromJSON,
    ExecRiskZoomInfoScanResultFromJSONTyped,
    ExecRiskZoomInfoScanResultToJSON,
} from './ExecRiskZoomInfoScanResult';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedZoomInfoResponse
 */
export interface ExecRiskPaginatedZoomInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskZoomInfoScanResult>}
     * @memberof ExecRiskPaginatedZoomInfoResponse
     */
    results: Array<ExecRiskZoomInfoScanResult>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedZoomInfoResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedZoomInfoResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedZoomInfoResponse interface.
 */
export function instanceOfExecRiskPaginatedZoomInfoResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedZoomInfoResponseFromJSON(json: any): ExecRiskPaginatedZoomInfoResponse {
    return ExecRiskPaginatedZoomInfoResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedZoomInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedZoomInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskZoomInfoScanResultFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedZoomInfoResponseToJSON(value?: ExecRiskPaginatedZoomInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskZoomInfoScanResultToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

